/* -----------------------------------------------------------------
   JAC'D UP CUSTOM - sleeve personalisation field.

   The PRICE of personalisation is handled by Shopify, not by this
   script: every Engraved product carries a third option, Sleeve,
   with values Blank ($55) and Personalized ($60). That was a
   deliberate choice over the usual pattern of a line-item property
   plus a hidden $5 add-on product bolted on with cart JS. Native
   variants mean the price updates itself, the cart and checkout are
   correct with no syncing, and there is no way to end up with an
   orphaned $5 line when someone removes the hoodie.

   What is left for this script is what a variant should NOT carry:
   the text, and which sleeve it goes on. Both ride along as
   line-item properties, which do not affect price - correct, because
   the variant already did. Left/right deliberately stayed a property
   rather than becoming a fourth option: as an option it would have
   doubled the variant count to 80 per product AND shown up as a
   choice even for people who picked Blank.

   The 10-character cap is a real production limit, so it is enforced
   three ways rather than one: maxlength on the input stops typing, a
   live counter shows the budget being spent, and the note says it in
   words. Ten fits a name or a verse REFERENCE ("Ps 139:14" is nine),
   not a verse.

   Three things make this harder than it looks.

   1. The Sleeve radios live inside <variant-selects>, which sits
      OUTSIDE the add-to-cart <form>. So these inputs are associated
      to the form by their `form` attribute instead of by nesting.
      Dawn submits with `new FormData(this.form)`, and FormData
      includes form-associated elements, so the properties are sent.

   2. Reading that form's id needs getAttribute('id'), NOT `.id`.
      The add-to-cart form contains <input name="id"> for the variant,
      and a form's named controls shadow the element's own properties,
      so `form.id` hands back the input element. The first version of
      this file did that and quietly wrote form="[object
      HTMLInputElement]", which associates with nothing - the field
      looked perfect and the property was never submitted.

   3. Dawn re-renders chunks of the product info block on every
      variant change, which can destroy this field mid-typing. Rather
      than guess which nodes survive, the typed value and the chosen
      side are held in `state` and re-applied on every sync, so they
      survive the nodes being thrown away and rebuilt.
   ----------------------------------------------------------------- */
(function () {
  'use strict';

  var TEXT_PROP = 'properties[Sleeve text]';
  var SIDE_PROP = 'properties[Sleeve side]';
  var MAXLEN = 10;
  var HINT = 'A name, a date, or a verse reference — stitched in the same tonal thread as the front.';
  var state = { text: '', side: 'Left' };
  var syncing = false;

  function sleeveFieldset() {
    var sets = document.querySelectorAll('.product-form__input--pill');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && lg.textContent.trim().toLowerCase().indexOf('sleeve') === 0) return sets[i];
    }
    return null;
  }

  function build() {
    var w = document.createElement('div');
    w.id = 'jd-personalise';
    w.className = 'jd-pers';
    w.innerHTML =
      '<div class="jd-pers__head">' +
        '<label class="jd-pers__label" for="jd-pers-input">Sleeve text</label>' +
        '<span class="jd-pers__count" aria-hidden="true"></span>' +
      '</div>' +
      '<input id="jd-pers-input" class="jd-pers__input" type="text" autocomplete="off" ' +
        'maxlength="' + MAXLEN + '" name="' + TEXT_PROP + '" placeholder="Ps 139:14">' +
      '<span class="jd-pers__label jd-pers__label--side">Which sleeve</span>' +
      '<div class="jd-pers__side" role="radiogroup" aria-label="Which sleeve">' +
        '<label class="jd-pers__side-opt">' +
          '<input type="radio" name="' + SIDE_PROP + '" value="Left"><span>Left</span>' +
        '</label>' +
        '<label class="jd-pers__side-opt">' +
          '<input type="radio" name="' + SIDE_PROP + '" value="Right"><span>Right</span>' +
        '</label>' +
      '</div>' +
      '<small class="jd-pers__note"></small>';
    return w;
  }

  function sync() {
    if (syncing) return;
    var fs = sleeveFieldset();
    if (!fs) return;

    syncing = true;
    try {
      var host = fs.closest('variant-selects') || fs;
      var w = document.getElementById('jd-personalise');
      if (!w || !w.isConnected) w = build();
      if (host.nextElementSibling !== w) host.insertAdjacentElement('afterend', w);

      var input = w.querySelector('.jd-pers__input');
      var note = w.querySelector('.jd-pers__note');
      var count = w.querySelector('.jd-pers__count');
      var sides = w.querySelectorAll('.jd-pers__side input');
      var btn = document.querySelector('button[name="add"]');
      var formEl = btn ? btn.closest('form') : null;
      var formId = formEl ? formEl.getAttribute('id') : null;

      var picked = fs.querySelector('input[type="radio"]:checked');
      var on = !!picked && picked.value === 'Personalized';

      if (formId) input.setAttribute('form', formId);
      input.disabled = !on;
      if (document.activeElement !== input && input.value !== state.text) {
        input.value = state.text;
      }

      for (var i = 0; i < sides.length; i++) {
        if (formId) sides[i].setAttribute('form', formId);
        sides[i].disabled = !on;
        sides[i].checked = sides[i].value === state.side;
      }

      w.hidden = !on;

      var used = state.text.length;
      count.textContent = used + '/' + MAXLEN;
      count.classList.toggle('jd-pers__count--full', used >= MAXLEN);

      var empty = on && !state.text.trim();
      note.textContent = empty ? 'Add your sleeve text to continue.' : HINT;
      note.classList.toggle('jd-pers__note--warn', empty);

      /* Only ever re-enable a button this script disabled - Shopify
         disables the same button for sold-out variants. */
      if (btn) {
        if (empty) {
          btn.setAttribute('disabled', 'disabled');
          btn.setAttribute('data-jd-blocked', '1');
        } else if (btn.hasAttribute('data-jd-blocked')) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-jd-blocked');
        }
      }
    } finally {
      syncing = false;
    }
  }

  function soon() {
    /* Dawn swaps nodes asynchronously after a variant change, so run
       once now and again after it has settled. */
    sync();
    setTimeout(sync, 60);
    setTimeout(sync, 400);
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'jd-pers-input') {
      state.text = e.target.value;
      sync();
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target) return;
    if (e.target.name === SIDE_PROP) {
      state.side = e.target.value;
      sync();
      return;
    }
    if (e.target.type === 'radio') soon();
  });

  function start() {
    soon();
    var root = document.getElementById('MainContent') || document.body;
    var timer = null;
    new MutationObserver(function () {
      if (syncing) return;
      clearTimeout(timer);
      timer = setTimeout(sync, 120);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
